export function isNotNullNorUndefined(val: Date | string | undefined | null | number): boolean {
    return val !== undefined && val !== null && val !== '';
}